var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_701_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.38542C0 5.41932 0 3.93627 0.586388 2.80742C1.08053 1.85616 1.85616 1.08053 2.80742 0.586388C3.93627 0 5.41932 0 8.38542 0H16.6146C19.5807 0 21.0637 0 22.1926 0.586388C23.1438 1.08053 23.9195 1.85616 24.4136 2.80742C25 3.93627 25 5.41932 25 8.38542V16.6146C25 19.5807 25 21.0637 24.4136 22.1926C23.9195 23.1438 23.1438 23.9195 22.1926 24.4136C21.0637 25 19.5807 25 16.6146 25H8.38542C5.41932 25 3.93627 25 2.80742 24.4136C1.85616 23.9195 1.08053 23.1438 0.586388 22.1926C0 21.0637 0 19.5807 0 16.6146V8.38542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5C12.5 10.918 13.7825 9.63541 15.3646 9.63541C16.9466 9.63541 18.2292 10.918 18.2292 12.5C18.2292 14.0821 16.9466 15.3646 15.3646 15.3646C13.7825 15.3646 12.5 14.0821 12.5 12.5Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77083 18.2291C6.77083 16.6471 8.05334 15.3645 9.63541 15.3645H12.5V18.2291C12.5 19.8112 11.2175 21.0937 9.63541 21.0937C8.05334 21.0937 6.77083 19.8112 6.77083 18.2291Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.90625V9.6354H15.3646C16.9467 9.6354 18.2292 8.35289 18.2292 6.77083C18.2292 5.18877 16.9467 3.90625 15.3646 3.90625H12.5Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77083 6.77083C6.77083 8.3529 8.05334 9.6354 9.63541 9.6354H12.5V3.90625H9.63541C8.05334 3.90625 6.77083 5.18877 6.77083 6.77083Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.77083 12.5C6.77083 14.0821 8.05334 15.3646 9.63541 15.3646H12.5V9.63541H9.63541C8.05334 9.63541 6.77083 10.918 6.77083 12.5Z",
    fill: "#A259FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.d21336b3e293b3ee692b05409770f9ff.svg";
export { ForwardRef as ReactComponent };